import React, { useEffect, useState } from "react";
import { emailRegex } from "../constant";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Switch,
  TextField,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { MembershipAPI } from "../../api/membership";
import { useAppContext } from "../../context/AppContext";
import { NumericFormat } from "react-number-format";

const GeneralInfoTab = ({ data, setRefetch }) => {
  const { openSnack } = useAppContext();
  const [formState, setFormState] = useState({
    first_name: "",
    last_name: "",
    company: "",
    chair: "",
    email_address: "",
    status: true,
    phone_number: "",
    date_started: "",
    membership_expiration_date: "",
    dues_paid: false,
    dues_paid_amount: "",
  });

  useEffect(() => {
    setFormState(data);
  }, [data]);

  const [formError, setFormError] = useState({});

  const handleError = (formObj = formState) => {
    const temp = { ...formError };

    if ("first_name" in formObj) {
      temp.first_name = formObj.first_name ? "" : "This field is required.";
    }

    if ("last_name" in formObj) {
      temp.last_name = formObj.last_name ? "" : "This field is required.";
    }

    if ("company" in formObj) {
      temp.company = formObj.company ? "" : "This field is required.";
    }

    if ("chair" in formObj) {
      temp.chair = formObj.chair ? "" : "This field is required.";
    }

    if ("email_address" in formObj) {
      temp.email_address = formObj.email_address
        ? ""
        : "This field is required.";

      temp.email_address = !emailRegex?.test(formObj.email_address)
        ? "Please enter valid Email Address!"
        : "";
    }

    if ("phone_number" in formObj) {
      temp.phone_number = formObj.phone_number ? "" : "This field is required.";
    }

    if ("date_started" in formObj) {
      temp.date_started = formObj.date_started ? "" : "This field is required.";
    }

    if ("membership_expiration_date" in formObj) {
      temp.membership_expiration_date = formObj.membership_expiration_date
        ? ""
        : "This field is required.";
    }

    if ("dues_paid_amount" in formObj) {
      temp.dues_paid_amount = formObj.dues_paid_amount
        ? ""
        : "This field is required.";
    }

    setFormError({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleChange = (key, value) => {
    setFormState((prevState) => ({ ...prevState, [key]: value }));
    handleError({ [key]: value });
  };

  const editMember = async (form) => {
    const { id, role, ...cleanForm } = form;

    const member = {
      ...cleanForm,
      dues_paid_amount: cleanForm.dues_paid_amount * 1,
      date_started: dayjs(cleanForm.date_started).format("YYYY-MM-DD"),
      membership_expiration_date: dayjs(
        cleanForm.membership_expiration_date,
      ).format("YYYY-MM-DD"),
    };

    try {
      await MembershipAPI.updateMember(member, data?.id);
      openSnack("Member information updated successfully.", "success");
      setRefetch(true);
    } catch (error) {
      console.error("Error adding member:", error);
    }
  };

  const handleSubmit = () => {
    if (handleError()) {
      editMember(formState);
    }
  };

  const renderForm = () => {
    return (
      <Grid
        container
        spacing={2}
        rowSpacing={2.5}
        sx={{
          paddingBottom: "16px",
        }}
      >
        <Grid item xs={12} sm={6}>
          <TextField
            margin="normal"
            fullWidth
            id="first_name"
            label="First Name*"
            name="first_name"
            value={formState?.first_name}
            onChange={(e) => handleChange("first_name", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.first_name}
            helperText={formError.first_name}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="normal"
            fullWidth
            id="last_name"
            label="Last Name*"
            name="last_name"
            value={formState?.last_name}
            onChange={(e) => handleChange("last_name", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.last_name}
            helperText={formError.last_name}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            margin="normal"
            fullWidth
            id="company"
            label="Company*"
            name="company"
            value={formState?.company}
            onChange={(e) => handleChange("company", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.company}
            helperText={formError.company}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="normal"
            fullWidth
            id="chair"
            label="Chair*"
            name="chair"
            value={formState?.chair}
            onChange={(e) => handleChange("chair", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.chair}
            helperText={formError.chair}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="normal"
            fullWidth
            id="email_address"
            label="Email Address*"
            name="email_address"
            value={formState?.email_address}
            onChange={(e) => handleChange("email_address", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.email_address}
            helperText={formError.email_address}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="normal"
            fullWidth
            id="phone_number"
            label="Phone Number*"
            name="phone_number"
            value={formState?.phone_number}
            onChange={(e) => handleChange("phone_number", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.phone_number}
            helperText={formError.phone_number}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="normal"
            fullWidth
            id="status"
            label="Status*"
            name="status"
            value={formState?.status}
            onChange={(e) => handleChange("status", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.status}
            helperText={formError.status}
            select
          >
            <MenuItem value={true}>Active</MenuItem>
            <MenuItem value={false}>Inactive</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={12} sm={6}>
          <DatePicker
            label="Date Started*"
            value={dayjs(formState?.date_started)}
            onChange={(newValue) => handleChange("date_started", newValue)}
            className="login-textField date-textField"
            sx={{ width: "100%", height: "40px" }}
            format="MM/DD/YYYY"
            slotProps={{
              textField: {
                margin: "normal",
                fullWidth: true,
                id: "date_started",
                name: "date_started",
                className: "login-textField",
                size: "small",
                error: !!formError.date_started,
                helperText: formError.date_started,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DatePicker
            label="Membership Expiration Date*"
            value={dayjs(formState?.membership_expiration_date) || null}
            onChange={(newValue) =>
              handleChange("membership_expiration_date", newValue)
            }
            className="login-textField date-textField"
            sx={{ width: "100%", height: "40px" }}
            format="MM/DD/YYYY"
            slotProps={{
              textField: {
                margin: "normal",
                fullWidth: true,
                id: "membership_expiration_date",
                name: "membership_expiration_date",
                // className: "login-textField",
                size: "small",
                error: !!formError.membership_expiration_date,
                helperText: formError.membership_expiration_date,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl component="fieldset" variant="standard" className="mt-6">
            <FormGroup>
              <FormControlLabel
                className="gap-4"
                control={
                  <Switch
                    checked={formState?.dues_paid}
                    onChange={(e) =>
                      handleChange("dues_paid", e.target.checked)
                    }
                    name="dues_paid"
                    className="switchStyles"
                  />
                }
                label="Dues Paid*"
              />
            </FormGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <NumericFormat
            value={formState?.dues_paid_amount}
            onValueChange={(e) => handleChange("dues_paid_amount", e.value)}
            customInput={TextField}
            thousandSeparator
            valueIsNumericString
            fixedDecimalScale
            decimalScale={2}
            prefix="$"
            label="Dues Paid Amount*"
            className="login-textField"
            error={!!formError.dues_paid_amount}
            helperText={formError.dues_paid_amount}
            size="small"
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <div>
      {renderForm()}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <Button onClick={handleSubmit} className="add-new-button button-common">
          Save
        </Button>
        <Link to={`/membership`} className="button-common light-blue-bg">
          Cancel
        </Link>
      </Box>
    </div>
  );
};

export default GeneralInfoTab;
